import { IStore } from "helpers";
import { createSlice } from "@reduxjs/toolkit";

export const pricingManagementReducer = createSlice({
  name: "pricingManagement store",
  initialState: { 
    matrixNameUpdate: "New Matrix", 
  },
  reducers: { 
    setMatrixNameUpdate: (state, action) => {
      state.matrixNameUpdate = action.payload;
    }
  },
});
export const { setMatrixNameUpdate} = pricingManagementReducer.actions;

export const getMatrixNameUpdate = (state: IStore) => state.pricingManagement.matrixNameUpdate; 

export default pricingManagementReducer.reducer;
